import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FilePlus2 } from "lucide-react";
import { PortalHeading } from "@/pages/portal/PortalLayout";
import { InsStatus } from "./InsurerLayout";
import { insApi } from "@/lib/insurance";
import { fmtDate } from "@/lib/api";

const Section = ({ title, items, testId, empty }) => (
  <section className="rounded-2xl bg-white p-5" data-testid={testId}>
    <div className="flex items-center justify-between mb-3">
      <h2 className="font-display font-bold text-[#0D141A]">{title}</h2>
      <span className="text-sm font-semibold text-[#020165]" data-testid={`${testId}-count`}>{items.length}</span>
    </div>
    <div className="divide-y">
      {items.slice(0, 6).map((r) => (
        <Link key={r.id} to={`/insurer/requests/${r.id}`} className="flex items-center justify-between gap-3 py-3 hover:bg-[#F4F4F4] -mx-2 px-2 rounded-lg" data-testid={`${testId}-item-${r.reference}`}>
          <div className="min-w-0">
            <p className="text-sm font-semibold text-[#0D141A] truncate">{r.claim_number} · {r.insured_name}</p>
            <p className="text-xs text-[#56585E] truncate">{r.vehicle?.make} {r.vehicle?.model} {r.vehicle?.registration} · {fmtDate(r.created_at)}</p>
          </div>
          <InsStatus status={r.status} />
        </Link>
      ))}
      {!items.length && <p className="py-4 text-sm text-[#56585E]">{empty}</p>}
    </div>
  </section>
);

export default function InsurerDashboard() {
  const [d, setD] = useState(null);
  useEffect(() => { insApi.get("/dashboard").then((r) => setD(r.data)); }, []);
  return (
    <div data-testid="insurer-dashboard">
      <PortalHeading title="Claims dashboard" sub="Your requests with Accelary Motors"
        action={<Link to="/insurer/request/new" data-testid="insurer-dashboard-new-request" className="inline-flex items-center gap-2 rounded-full bg-[#F86900] px-5 py-2.5 text-sm font-bold text-[#0D141A] hover:bg-[#ff7a1a] transition-colors"><FilePlus2 className="h-4 w-4" />New quote request</Link>} />
      {d && (
        <div className="grid gap-5 lg:grid-cols-3">
          <Section title="Quotes awaiting your review" items={d.pending_quotes} testId="insurer-pending-quotes" empty="No quotes waiting on you." />
          <Section title="Open requests" items={d.open} testId="insurer-open-requests" empty="No open requests." />
          <Section title="Accepted & closed" items={d.closed} testId="insurer-closed-requests" empty="Nothing closed yet." />
        </div>
      )}
    </div>
  );
}
